<template>
  <div class="ai-jd-card" @click="$emit('open', jd)">
    <div class="ai-jd-card-rank">#{{ rank }}</div>
    <div class="ai-jd-card-body">
      <div class="ai-jd-card-title">{{ jd.job_title }}</div>
      <div class="ai-jd-card-location">{{ jd.location }}</div>
    </div>
    <div class="ai-jd-card-score" v-if="jd.llm_score">LLMスコア: {{ jd.llm_score }}点</div>
  </div>
</template>

<script>
export default {
  name: 'AiJdMatchCard',
  props: {
    jd: {
      type: Object,
      required: true,
    },
    // Display position (1-based) — jd.jd_rank isn't reliably sequential.
    rank: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
.ai-jd-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border: 1px solid #c4c4c4;
  border-radius: 8px;
  background-color: #fff;
  cursor: pointer;
  margin-bottom: 8px;
  transition: border-color 0.2s, background-color 0.2s;
}

.ai-jd-card:hover {
  border-color: #036d6c;
  background-color: #f0f5f7;
}

.ai-jd-card-rank {
  flex-shrink: 0;
  font-weight: bold;
  color: #036d6c;
  font-size: 13px;
  min-width: 28px;
}

.ai-jd-card-body {
  flex: 1;
  min-width: 0;
}

.ai-jd-card-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ai-jd-card-location {
  font-size: 12px;
  color: #787878;
  margin-top: 2px;
}

.ai-jd-card-score {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: bold;
  color: #036d6c;
  white-space: nowrap;
}
</style>
